import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=40073af8&scoped=true&"
import script from "./EditorMenu.vue?vue&type=script&lang=ts&"
export * from "./EditorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&id=40073af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40073af8",
  null
  
)

export default component.exports